__webpack_require__.p = "/team00-s23-6pm-1/";